import { BasePropertyApi } from './base-api.interface';
import { getBorderColor } from './get-common-properties';
import { updateBorderColor } from './update-common-properties';

export const borderColorAPI: BasePropertyApi = {
  get: getBorderColor,
  update: updateBorderColor,
};
